import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * cn — class name utility used throughout GradNomad UI components.
 *
 * Combines clsx (conditional class logic) with tailwind-merge (deduplicates
 * conflicting Tailwind utility classes so the last one wins). This is the
 * standard shadcn/ui pattern.
 *
 * @example
 *   cn('px-4 py-2', isActive && 'bg-brand-blue text-white', className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
